/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Order class.
 */
export enum OrderClass {
    MARKET = 'market',
    LIMIT = 'limit',
    LIQUIDITY = 'liquidity',
}
